//copy block event
function copyEvent(event: any) {
  event.clipboardData?.setData("text/plain", "This content is lovingly crafted and copyrighted by © Get Set 4 Education. You are unauthorised to share, distribute, or reproduce this material, as it is unlawful to do so. Thank you for your co-operation!");
  event.preventDefault();
  event.stopPropagation();
}

//block copy and paste function
export const BlockCopyandPaste = () => {
  //list of all elements, details of elements to avoid blocking, and arrays holding elements to block, to no block and containing class names
  const eleList: any = document.querySelectorAll("*");
  const avoidEleEvents = [
    { type: "node", value: "input", wholeSection: false }, 
    { type: "singleClass", value: "email", wholeSection: false },
    { type: "wholeSection", value: "NewSubscriptionPage", wholeSection: true },
  ];
  let eleListEventAdd = [];
  let eleListEventRemove = [];
  let removeWholeSectionEvents = [];

  //remove any existing copy events
  for(let i = 0; i < eleList.length; i++){
    eleList[i].removeEventListener("copy", copyEvent);
  }  

   //loop through all elements and sort them into block/avoid arrays, depending on whether they meet blocking details array criteria or not
  for(let j = 0; j < eleList.length; j++){
    let addEle = true;

    for(let k = 0; k < avoidEleEvents.length; k++){
      if(
        (avoidEleEvents[k].type === "node" && typeof eleList[j].nodeName === "string" && eleList[j].nodeName.toLowerCase() === avoidEleEvents[k].value) ||
        (avoidEleEvents[k].type === "singleClass" && typeof eleList[j].className === "string" && eleList[j].className.toLowerCase().indexOf(avoidEleEvents[k].value) > -1) ||
        (avoidEleEvents[k].wholeSection && typeof eleList[j].className === "string" && eleList[j].className.toLowerCase().indexOf(avoidEleEvents[k].value.toLowerCase()) > -1)
      ) {
        addEle = false;
        
        if(avoidEleEvents[k].wholeSection){
          removeWholeSectionEvents.push(avoidEleEvents[k].value);
        }
      }
    }

    if(addEle){
      if(removeWholeSectionEvents.length > 0){
        let removeEle = false;

        for(let n = 0; n < removeWholeSectionEvents.length; n++){
          if(eleList[j].parentNode.closest("." + removeWholeSectionEvents[n])){
            removeEle = true;
            break;
          }
        }

        if(removeEle){
          eleListEventRemove.push(eleList[j]);
        } else {
          eleListEventAdd.push(eleList[j]);
        }
      } else {
        eleListEventAdd.push(eleList[j]);
      }
    } else {
      eleListEventRemove.push(eleList[j]);
    }
  }

  //clear containing class names
  removeWholeSectionEvents = [];

  //add copy event listeners
  for(let l = 0; l < eleListEventAdd.length; l++){
    eleListEventAdd[l].addEventListener("copy", copyEvent);
  }

  //negate copy event listeners
  for(let m = 0; m < eleListEventRemove.length; m++){
    eleListEventRemove[m].addEventListener("copy", (event: any) => {
      event.stopPropagation();
    }); 
  }
};